import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@/app/common/utils/pagination/types';
import { FleetApiService } from '../infra/api.service';
import { FleetFindAllParams, FleetVehicle } from './type';

@Injectable({ providedIn: 'root', useClass: FleetApiService })
export abstract class FleetService {
  abstract findAll(
    filter?: FleetFindAllParams,
  ): Observable<PaginatedResponse<FleetVehicle>>;

  abstract findByChassis(chassis: string): Observable<FleetVehicle>;
}
